<template>
  <div id="album-picture-swipe">
    <div class="year" v-for="year in postYear" :key="year">
      <p>{{ year }}年</p>
      <div class="month" v-for="month in postMonth(year)" :key="month">
        <p>{{ month }}月</p>
        <div class="img-container">
          <!-- gallery -->
          <div class="my-gallery" itemscope itemtype="http://schema.org/ImageGallery">
            <figure v-for="(item, key) in postImg(year, month)" :key="key" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
              <a :href="item" itemprop="contentUrl" :data-size="width + 'x' + height">
                <img class="thumbnail" :src="item" itemprop="thumbnail" alt="Image description" />
              </a>
            </figure>
          </div>
          <!-- Root element of PhotoSwipe. Must have class pswp. -->
          <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
            <!-- Background of PhotoSwipe. 
         It's a separate element, as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

            <!-- Slides wrapper with overflow:hidden. -->
            <div class="pswp__scroll-wrap">
              <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
              <!-- don't modify these 3 pswp__item elements, data is added later on. -->
              <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
              </div>

              <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
              <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar">
                  <!--  Controls are self-explanatory. Order can be changed. -->

                  <div class="pswp__counter"></div>

                  <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                  <!-- <button class="pswp__button pswp__button--share" title="Share"></button> -->

                  <!-- <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> -->

                  <!-- <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button> -->

                  <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                  <!-- element will get class pswp__preloader--active when preloader is running -->
                  <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                      <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                  <div class="pswp__share-tooltip"></div>
                </div>

                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>

                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>

                <div class="pswp__caption">
                  <div class="pswp__caption__center"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="!isLastPage" class="load-more" @click="showAlbumImgs(flag), (flag += 21)">查看更多</p>
    <div :class="{ 'bottom-ios': iOS, 'bottom-android': !iOS }"></div>
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      flag: 21,
      width: window.innerWidth,
      height: window.innerHeight,
      iOS: false
    };
  },
  computed: {
    ...mapState('AlbumModule', ['imgList', 'isLastPage']),
    ...mapGetters(['getIsSetSession']),
    isSetSession() {
      return this.getIsSetSession;
    },
    // 取出年份
    postYear() {
      let years = this.imgList.map(item => {
        return item.Year;
      });
      return [...new Set(years)];
    }
  },
  methods: {
    ...mapActions('AlbumModule', ['showAlbumImgs']),
    // 用年份取出月份
    postMonth(year) {
      let month = this.imgList.filter(item => {
        return item.Year == year;
      });
      month = month.map(item => {
        return item.Month;
      });
      return [...new Set(month)];
    },
    // 用年份 & 月份取出相片
    postImg(year, month) {
      let img = this.imgList.filter(item => {
        return item.Year == year && item.Month == month;
      });
      img = img.map(item => {
        return item.Path;
      });
      return img;
    },
    initPhotoSwipeFromDOM(gallerySelector) {
      // parse slide data (url, title, size ...) from DOM elements
      // (children of gallerySelector)
      let parseThumbnailElements = function(el) {
        let thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          linkEl,
          size,
          item;

        for (let i = 0; i < numNodes; i++) {
          figureEl = thumbElements[i]; // <figure> element

          // include only element nodes
          if (figureEl.nodeType !== 1) {
            continue;
          }

          linkEl = figureEl.children[0]; // <a> element

          size = linkEl.getAttribute('data-size').split('x');

          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
          };

          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
          }

          item.el = figureEl; // save link to element for getThumbBoundsFn
          items.push(item);
        }

        return items;
      };

      // find nearest parent element
      let closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      };

      // triggers when user clicks on thumbnail
      let onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);

        let eTarget = e.target || e.srcElement;

        // find root element of slide
        let clickedListItem = closest(eTarget, function(el) {
          return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
        });

        if (!clickedListItem) {
          return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        let clickedGallery = clickedListItem.parentNode;
        let childNodes = clickedListItem.parentNode.childNodes;
        let numChildNodes = childNodes.length;
        let nodeIndex = 0;
        let index;

        for (let i = 0; i < numChildNodes; i++) {
          if (childNodes[i].nodeType !== 1) {
            continue;
          }

          if (childNodes[i] === clickedListItem) {
            index = nodeIndex;
            console.log('index: ' + index);
            break;
          }
          nodeIndex++;
        }

        if (index >= 0) {
          // open PhotoSwipe if valid index found
          openPhotoSwipe(index, clickedGallery);
        }
        return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      let photoswipeParseHash = function() {
        let hash = window.location.hash.substring(1),
          params = {};

        if (hash.length < 5) {
          return params;
        }

        let lets = hash.split('&');
        for (let i = 0; i < lets.length; i++) {
          if (!lets[i]) {
            continue;
          }
          let pair = lets[i].split('=');
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }

        if (params.gid) {
          params.gid = parseInt(params.gid, 10);
        }

        return params;
      };

      let openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        let pswpElement = document.querySelectorAll('.pswp')[0],
          gallery,
          options,
          items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
          // define gallery index (for URL)
          galleryUID: galleryElement.getAttribute('data-pswp-uid'),

          getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            let thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };

        // PhotoSwipe opened from URL
        if (fromURL) {
          if (options.galleryPIDs) {
            // parse real index when custom PIDs are used
            // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
            for (let j = 0; j < items.length; j++) {
              if (items[j].pid == index) {
                options.index = j;
                break;
              }
            }
          } else {
            // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
          }
        } else {
          options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
          return;
        }

        if (disableAnimation) {
          options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options);
        gallery.init();
      };

      // loop through all gallery elements and bind events
      let galleryElements = document.querySelectorAll(gallerySelector);

      for (let i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      let hashData = photoswipeParseHash();
      if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
      }
    }
  },
  updated() {
    this.initPhotoSwipeFromDOM('.my-gallery');
  },
  watch: {
    // 監聽若 isSetSession 存入狀況變動要觸發取得貼文牆資料
    isSetSession: function() {
      this.showAlbumImgs(0);
    }
  },
  mounted() {
    // 判斷裝置
    const myUserAgent = navigator.userAgent;
    this.iOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  }
};
</script>

<style scoped lang="scss">
#album-picture-swipe {
  width: 95vw;
  margin: 0 auto 0 auto;
  p {
    font-size: 17px;
    color: #888;
  }
  .year > p {
    margin-bottom: 2vw;
  }
  .month {
    display: flex;
    margin-bottom: 1vw;
    .img-container {
      display: flex;
      flex-wrap: wrap;
      width: 81vw; // 25vw * 3 + 2vw * 3
      margin-left: auto;
    }
    .my-gallery {
      line-height: 0;
    }
    figure {
      display: inline;
      margin: 0;
    }
    .thumbnail {
      width: 25vw;
      height: 25vw;
      object-fit: cover;
      border-radius: 5px;
      margin: 0 0 2vw 2vw;
    }
    .pswp__img {
      object-fit: contain;
    }
  }
  .load-more {
    margin: 2vw auto;
    text-align: center;
  }
  .bottom-ios {
    height: 12vh;
  }
  .bottom-android {
    height: 5vh;
  }
}
</style>
<style lang="scss">
// 從相簿進入推高
.pushiOS {
  .pswp__img {
    top: -6vh;
  }
}
</style>
